import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CFETILMEndpointsConstant } from '../constants/cfet-ilm-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class SheeridApiService {
  
  constructor(private readonly http: HttpClient) {}

  sendSheerIdApiIntegrationData(payload: any): Observable<any> {
    const url = `${environment.getApiLiveUrl()}${CFETILMEndpointsConstant.ILMSheerIdApi}user-verification`;
    return this.http.post(url, payload);
  }

  getCurrentETTime(): string {
    const now = new Date();
    // Convert current time to Eastern Time
    const etDate = new Date(
      now.toLocaleString("en-US", { timeZone: "America/New_York" }),
    );
    const year = etDate.getFullYear();
    const month = String(etDate.getMonth() + 1).padStart(2, '0');
    const day = String(etDate.getDate()).padStart(2, '0');
    const hours = String(etDate.getHours()).padStart(2, '0');
    const minutes = String(etDate.getMinutes()).padStart(2, '0');
    const seconds = String(etDate.getSeconds()).padStart(2, '0');
    // Microseconds-like format (5 digits)
    const micro = String(etDate.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${micro}`;
  }

}